import React, { FunctionComponent } from 'react';
import { PersonShowModalInterestState } from './types';
import { TextBox } from '../../atoms/textBox';
import { RemainingLength } from '../../atoms/remainingLength';

type Props = {
  state: PersonShowModalInterestState;
  onChangeBody: (name: string, value: string) => void;
  handleClick: (value: string) => void;
  handleDelete: (value: string) => void;
  handleSend: (value: string) => void;
  handleClearSuggest: () => void;
};

export const Presentation: FunctionComponent<Props> = ({
  state,
  onChangeBody,
  handleClick,
  handleDelete,
  handleSend,
  handleClearSuggest,
}) => {
  return (
    <div className="person__show__modal__inner" onClick={handleClearSuggest}>
      <p className="person__show__modal__inner--title">候補の中から選択するか入力して保存してください</p>
      <div className="person__show__modal__inner__skills">
        <TextBox
          className='person__show__modal__inner__skills--input'
          placeholder='興味・関心を入力してください'
          onChanged={(name, value) => onChangeBody(name, value)}
          name='targetInterest'
          value={state.targetInterest}
          handleSend={() => handleSend(state.targetInterest)}
          enterKeyHint='done'
          maxLength={255}
        />
        <RemainingLength
          remaining={255 - state.targetInterest.length}
          className="person__show__modal__inner--hint"
        />
        <ul className={`person__show__modal__inner__skills--suggestions ${state.suggestInterests.length > 0 ? 'active' : ''}`}>
          {state.suggestInterests.map((interest) => (
            <li key={interest.title} onClick={() => handleClick(interest.title)}>
              <p className="skill--title">{interest.title}</p>
              <p className="skill--count">{interest.count}人が登録しています</p>
            </li>
          ))}
        </ul>
      </div>
      <div className="person__show__modal__inner__skills--box">
        <p className="semiTitle">追加した興味・関心</p>
        {state.interests.length > 0 ? (
          <ul>
            {state.interests.map((interest) => (
              <li key={interest}>
                <span>{interest}</span>
                <svg onClick={() => handleDelete(interest)} xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M0.735395 12L0 11.2646L5.26461 6L0 0.735394L0.735395 0L6 5.26461L11.2646 0L12 0.735394L6.7354 6L12 11.2646L11.2646 12L6 6.73539L0.735395 12Z" fill="#19190F"/>
                </svg>
              </li>
            ))}
          </ul>
        ) : (
          <p className="person__show__modal__inner__skills--empty">興味・関心はまだ追加されていません</p>
        )}
      </div>
      <div className="person__show__modal__inner__skills--box">
        <p className="semiTitle">候補</p>
        {state.recommendInterests.length > 0 ? (
          <ul className="suggestions">
            {state.recommendInterests.map((interest) => (
              <li key={interest} onClick={() => handleClick(interest)}>
                <p className="skill--title">{interest}</p>
              </li>
            ))}
          </ul>
        ) : (
          <p className="person__show__modal__inner__skills--empty">候補はありません</p>
        )}
      </div>
    </div>
  );
};
